import React from "react";
import Graph from "react-graph-vis"; //https://github.com/crubier/react-graph-vis#readme
import CubeGraphErrorBoundary from "./CubeGraphErrorBoundary";
import { inject, observer } from "mobx-react";

let ctx;
let refnetwork;
let refcontainer;
let refcanvas;
let refnodes;
let rect = [];
let drawingSurfaceImageData;
@inject("http", "searchStore", "graphicalRepresentationStore")
@observer
class CubeGraph extends React.Component {
  constructor(props) {
    super(props);
    this.networkCanFit = true;
    this.state = {
      drag: false,
      network: {},
      physics: false,
      hierarchical: true,
    };
    this.canvasWrapperRef = React.createRef();
  }

  componentDidMount() {
    const { setGraph, graph, setActiveNode, resetBaseGraph } =
      this.props.graphicalRepresentationStore;
    const { selectAll } = this.props;
    setGraph({
      nodes: [],
      edges: [],
    });
    resetBaseGraph();
    selectAll();
    setActiveNode([]);

    refcontainer = this.canvasWrapperRef.current.Network.canvas.frame;
    refnetwork = this.canvasWrapperRef.current.Network;
    refcanvas = this.canvasWrapperRef.current.Network.canvas.frame.canvas;
    refnodes = graph.nodes;
    ctx = refcanvas.getContext("2d");

    refcontainer.oncontextmenu = function () {
      return false;
    };

    this.saveDrawingSurface();

    // add event watching for canvas box drawing
    refcontainer.addEventListener("mousedown", (e) => {
      e.preventDefault();

      if (e.button === 2) {
        rect.w = 0;
        rect.h = 0;
        this.saveDrawingSurface();
        rect.startX = e.offsetX;
        rect.startY = e.offsetY;
        this.drag = true;
        refcontainer.style.cursor = "default";
        this.selectNodesFromHighlight();
      }
    });

    refcontainer.addEventListener("mousemove", (e) => {
      if (this.drag) {
        this.restoreDrawingSurface();
        rect.w =
          e.offsetX -
          this.canvasWrapperRef.current.Network.body.container.offsetLeft -
          rect.startX;
        rect.h =
          e.offsetY -
          this.canvasWrapperRef.current.Network.body.container.offsetTop -
          rect.startY +
          30;

        ctx.setLineDash([5]);
        ctx.strokeStyle = "rgb(33, 55, 141)";
        ctx.strokeRect(rect.startX, rect.startY, rect.w, rect.h);
        ctx.setLineDash([]);
        ctx.fillStyle = "rgba(33, 55, 141, 0.2)";
        ctx.fillRect(rect.startX, rect.startY, rect.w, rect.h);
      }
    });

    refcontainer.addEventListener("mouseup", (e) => {
      if (e.button === 2) {
        this.restoreDrawingSurface();
        this.drag = false;
        refcontainer.style.cursor = "default";
        this.selectNodesFromHighlight();
      }
    });
  }
  componentWillUnmount() {
    const { setGroups } = this.props.graphicalRepresentationStore;
    setGroups(null);
  }

  async componentDidUpdate(nextProps, nextState) {
    const { network, hierarchical } = this.state;
    const { cubes, relationships } = this.props;

    const { visibleItems, getActiveNode, setGraph, graph } =
      this.props.graphicalRepresentationStore;
    this.networkCanFit = true;
    if (nextProps.cubes !== cubes || nextState.hierarchical !== hierarchical) {
      setGraph(cubes, relationships, hierarchical);
    }
    if (visibleItems.includes(getActiveNode)) {
      network.setSelection({
        nodes: [getActiveNode],
      });
      network.focus(getActiveNode);
    }
    if (hierarchical) {
      setTimeout(() => {
        network.setOptions({
          layout: {
            hierarchical: false,
          },
        });
        network.setOptions({
          physics: {
            enabled: false,
          },
        });
        network.fit();
      }, 100);
    }
    refcontainer = this.canvasWrapperRef.current.Network.canvas.frame;
    refnetwork = this.canvasWrapperRef.current.Network;
    refcanvas = this.canvasWrapperRef.current.Network.canvas.frame.canvas;
    refnodes = graph.nodes;
    ctx = refcanvas.getContext("2d");
  }

  async shouldComponentUpdate(nextProps, nextState) {
    const { cubes } = this.props;
    const { physics } = this.state;
    return nextProps.cubes !== cubes || nextState.physics !== physics;
  }
  saveDrawingSurface = () => {
    drawingSurfaceImageData = ctx.getImageData(
      0,
      0,
      refcanvas.width,
      refcanvas.height
    );
  };

  restoreDrawingSurface = () => {
    ctx.putImageData(drawingSurfaceImageData, 0, 0);
  };

  selectNodesFromHighlight = () => {
    let nodesIdInDrawing = [];
    let xRange = this.getStartToEnd(rect.startX, rect.w);
    let yRange = this.getStartToEnd(rect.startY, rect.h);
    let allNodes = refnodes;
    for (const node of allNodes) {
      let curNode = node;
      let nodePosition = refnetwork.getPositions([curNode.id]);
      let nodeXY = refnetwork.canvasToDOM({
        x: nodePosition[curNode.id].x,
        y: nodePosition[curNode.id].y,
      });
      if (
        xRange.start <= nodeXY.x &&
        nodeXY.x <= xRange.end &&
        yRange.start <= nodeXY.y &&
        nodeXY.y <= yRange.end
      ) {
        nodesIdInDrawing.push(curNode.id);
      }
    }
    refnetwork.selectNodes(nodesIdInDrawing);
    refnetwork.redraw();
  };

  getStartToEnd = (start, theLen) => {
    return theLen > 0
      ? {
          start: start,
          end: start + theLen,
        }
      : {
          start: start + theLen,
          end: start,
        };
  };

  getOptions = () => {
    const { physics } = this.state;
    const { groups } = this.props.graphicalRepresentationStore;
    return {
      autoResize: true,
      layout: {
        randomSeed: undefined,
        improvedLayout: true,
        clusterThreshold: 150,
      },
      interaction: {
        hover: true,
        multiselect: true,
        navigationButtons: true,
      },
      groups: groups ? groups : {},
      nodes: {
        shape: "box",
        font: {
          multi: "html",
          bold: "18px arial black",
          align: "left",
        },
        scaling: {
          min: 10,
          max: 30,
        },
        widthConstraint: { maximum: 250 },
        labelHighlightBold: false,
      },
      edges: {
        hoverWidth: function (width) {
          return width * 100;
        },
        smooth: false,
        font: {
          align: "middle",
        },
      },
      physics: {
        enabled: physics,
        hierarchicalRepulsion: {
          nodeDistance: 50,
        },
        barnesHut: {
          springLength: 200,
          centralGravity: 0.3,
          avoidOverlap: 0.1,
          damping: 0.2,
          gravitationalConstant: -5000,
        },
        maxVelocity: 500,
        minVelocity: 3,
        solver: "barnesHut",
        stabilization: {
          enabled: false,
          iterations: 1000,
          updateInterval: 100,
          onlyDynamicEdges: false,
          fit: true,
        },
        timestep: 0.5,
      },
    };
  };

  getGraphEvents = () => {
    return {
      select: (event) => {
        const { onNodeClick, onEdgeClick } = this.props;
        const { network } = this.state;
        const { nodes, edges } = event;
        if (nodes.length > 0) {
          if (network.isCluster(nodes[0]) === false) {
            onNodeClick(nodes[0]);
          }
        } else {
          if (edges.length > 0) {
            onEdgeClick(edges[0]);
          }
        }
      },
      doubleClick: (event) => {
        const { nodes } = event;
        if (nodes.length === 1) {
          try {
            window.open(
              `${!window?.__env?.USE_NEW_ROUTING ? "/#" : ""}/view/Cube/${
                nodes[0].split("-")[0]
              }/`,
              "_blank"
            );
          } catch (error) {
            console.log(error);
          }
        }
      },
      dragStart: (event) => {
        const { nodes } = event;
        const { network } = this.state;
        network.setSelection({
          nodes: nodes,
        });
      },
      afterDrawing: () => {
        const { network } = this.state;
        if (this.networkCanFit) {
          this.networkCanFit = false;
          network.fit();
        }
      },
    };
  };
  togglePhysics = () => {
    const { physics } = this.state;
    this.setState({
      physics: !physics,
    });
  };
  changeDisplayingMode = () => {
    const { hierarchical } = this.state;
    this.setState(
      {
        hierarchical: !hierarchical,
      },
      () => {
        this.networkCanFit = true;
        if (hierarchical !== true) {
          this.setState({
            physics: false,
          });
        } else {
          this.setState({
            physics: true,
          });
        }
      }
    );
  };

  render() {
    const { graph } = this.props.graphicalRepresentationStore;
    return (
      <React.Fragment>
        <CubeGraphErrorBoundary>
          <Graph
            ref={this.canvasWrapperRef}
            graph={graph}
            options={this.getOptions()}
            events={this.getGraphEvents()}
            getNetwork={(network) => {
              this.setState({ network });
            }}
          />
        </CubeGraphErrorBoundary>
        <></>
      </React.Fragment>
    );
  }
}
export default CubeGraph;
